/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */

/**
 * Declares that the property is delegated to same named property of targetField.
 * In other words:
 *
 * ```ts
 * class C {
 *     @delegateTo('q') declare f;
 * }
 * ```
 *
 * is equivalent to:
 *
 * ```ts
 * class C {
 *     get f() { return this.q?.f; }
 *     set f(value) { if (this.q) this.q.f = value; }
 * }
 * ```
 *
 * @param targetField Field of current object to delegate to
 * @returns property decorator
 */
export function delegateTo(targetField: string) {
    return function (target: unknown, propertyKey: string) {
        Object.defineProperty(target, propertyKey, {
            get() {
                return this[targetField]?.[propertyKey];
            },
            set(value: unknown) {
                if (this[targetField]) {
                    this[targetField][propertyKey] = value;
                }
            },
            enumerable: true,
            configurable: true,
        });
    };
}
